// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___2QCQn","flex":"flex___kRKvn","label":"label___3slgc","left":"left___1jcKH","divider":"divider___2e7dA"};